module.exports = __webpack_public_path__ + "img/opensourcejob-graphic.976dec4d.svg";